export class SoluuError extends Error {
    code;
    cause;
    constructor(code, message, cause) {
        super(message);
        this.name = 'SoluuError';
        this.code = code;
        if (cause !== undefined) {
            this.cause = cause;
        }
    }
}
// Wraps an arbitrary thrown value into a SoluuError with the best-fitting
// code. `fallback` is used when the underlying error doesn't strongly
// imply a specific code (e.g., a plain Error or an unrecognized DOMException
// name). Mapping rules mirror Web Bluetooth's documented exception names.
export function toSoluuError(cause, fallback = 'GATT_ERROR') {
    if (cause instanceof SoluuError) {
        return cause;
    }
    if (cause instanceof DOMException) {
        const code = mapDomExceptionToCode(cause.name, fallback);
        return new SoluuError(code, `${cause.name}: ${cause.message}`, cause);
    }
    if (cause instanceof Error) {
        return new SoluuError(fallback, cause.message, cause);
    }
    if (typeof cause === 'string') {
        return new SoluuError('UNKNOWN', cause, cause);
    }
    return new SoluuError('UNKNOWN', 'Unknown error', cause);
}
function mapDomExceptionToCode(name, fallback) {
    switch (name) {
        case 'SecurityError':
        case 'NotAllowedError':
            // SPEC: UNAUTHORIZED is surfaced when a write fails in a way
            // consistent with the device being locked.
            return 'UNAUTHORIZED';
        case 'TimeoutError':
            return 'TIMEOUT';
        case 'InvalidStateError':
            return 'NOT_CONNECTED';
        case 'NetworkError':
        case 'NotFoundError':
        case 'NotSupportedError':
        case 'AbortError':
            return 'GATT_ERROR';
        default:
            return fallback;
    }
}
//# sourceMappingURL=errors.js.map